// Cities served — used across SEO pages for location targeting
export const CITIES = [
  { name: "San Jose", region: "Bay Area, CA", zip: "95101" },
  { name: "Bay Area", region: "California", zip: "" },
  { name: "Sacramento", region: "California", zip: "95814" },
  { name: "Concord", region: "Bay Area, CA", zip: "94518" },
  { name: "Vacaville", region: "California", zip: "95687" },
  { name: "Modesto", region: "Central Valley, CA", zip: "95350" },
  { name: "Santa Rosa", region: "North Bay, CA", zip: "95401" },
  { name: "Reno", region: "Nevada", zip: "89501" },
  { name: "Walnut Creek", region: "Bay Area, CA", zip: "94596" },
  { name: "Fremont", region: "Bay Area, CA", zip: "94536" },
  { name: "Oakland", region: "Bay Area, CA", zip: "94601" },
  { name: "Pleasanton", region: "Bay Area, CA", zip: "94566" },
];

const CALL_NOW = "(510) 507-9318";

export const SERVICE_PAGES = {
  "gazebo-installer": {
    slug: "gazebo-installer",
    canonical: "/gazebo-installer",
    metaTitle:
      "Gazebo Installation Quote Requests Nationwide | Xavier Assembly",
    metaDescription:
      "Request a gazebo installation quote from anywhere in the U.S. Share your model, ZIP and site details; our team confirms local installation availability.",
    keywords:
      "gazebo installer, gazebo installation California, gazebo installer Bay Area, gazebo installer San Jose, gazebo installer Sacramento, gazebo installer Reno, wooden gazebo installation, hardtop gazebo installer",
    eyebrow: "Gazebo Installer",
    h1: "Gazebo Installation Quote Requests Nationwide",
    intro:
      "Hardtop, soft-top, wooden, aluminum or pop-up — Xavier Assembly installs every gazebo the way the manufacturer intended. Level foundations, torque-spec hardware, sealed connections and a spotless site. Contact our team about customer references and projects in the Bay Area, Sacramento Valley and Reno.",
    heroImage:
      "https://static.prod-images.emergentagent.com/jobs/1271818a-d288-4bc7-b67d-404fdc5a13fe/images/76772547beac3bdc032dcb9cdf38a4a1f6137e70b86a207645f8adca44da3ef4.png",
    benefits: [
      {
        title: "Factory-Spec Assembly",
        desc: "Every bolt torqued, every panel sealed. We follow Yardistry, Costco, Sojag & TOJA factory manuals to the letter.",
      },
      {
        title: "Anchored & Wind-Rated",
        desc: "Anchoring options are reviewed for your product, site conditions and local requirements before the work is agreed.",
      },
      {
        title: "Same-Day Completion",
        desc: "Most 10×12 and 12×14 gazebos installed in a single day. Bigger pavilions 1–2 days.",
      },
      {
        title: "Costco & Yardistry Specialists",
        desc: "Share your Costco gazebo model for a project-specific review. We know the quirks, missing hardware fixes, and finish steps that elevate the result.",
      },
    ],
    process: [
      "Free phone consultation & site review (photos or in-person)",
      "Written quote after review of your product, site and requested scope",
      "Scheduled delivery & site prep (we can level dirt, build a pad, or work on existing decks/patios)",
      "Same-day or next-day full assembly with our 2–4 person crew",
      "Final walkthrough and assembly-area cleanup; packaging, trash and pallet removal only as quoted and agreed",
    ],
    brands: ["Yardistry", "Costco", "Sojag", "TOJA Grid", "Backyard Discovery", "Sunjoy"],
    faq: [
      {
        q: "How much does professional gazebo installation cost in California?",
        a: "Most Costco and Yardistry gazebo installs in California & Reno range from $850 to $2,400 depending on size (10×10 vs 12×16 vs 14×16), substrate (grass, concrete, deck) and hardware upgrades. We provide fixed-price written quotes — no hourly surprises.",
      },
      {
        q: "Do you install gazebos purchased from Costco?",
        a: "Yes — Yardistry from Costco is one of our most-installed products. We're familiar with every kit they carry. We can also help diagnose missing hardware before your install date so the job stays on schedule.",
      },
      {
        q: "Can you install on grass, concrete or an existing deck?",
        a: "All three. We bring concrete anchors, lag bolts for decks, and ground spike anchors for grass. We'll recommend the right option during your free consultation.",
      },
      {
        q: "Do you serve Reno and the Sacramento Valley?",
        a: "Yes. Our crews regularly travel to Reno, Sacramento, Vacaville, Modesto, Concord, Santa Rosa and the entire Bay Area. Travel is included in your quote — no hidden trip charges.",
      },
      {
        q: "Are you insured?",
        a: "Ask our team to confirm the insurance documentation and any HOA requirements applicable to your specific installation before scheduling.",
      },
    ],
    cta: "Get your free gazebo installation quote",
  },

  "pergola-installer": {
    slug: "pergola-installer",
    canonical: "/pergola-installer",
    metaTitle:
      "Pergola Installation Quote Requests Nationwide | Xavier Assembly",
    metaDescription:
      "Request a pergola installation quote from anywhere in the U.S. Verified models get an automatic quote; PERGOLUX and BON PERGOLA requests are reviewed manually and our team confirms local installation availability.",
    keywords:
      "pergola installer, pergola installation California, aluminum pergola installer, louvered pergola installer, modern pergola Bay Area, pergola installer Sacramento, pergola installer Reno",
    eyebrow: "Pergola Installer",
    h1: "Pergola Installation Quote Requests Nationwide",
    intro:
      "From cedar craftsman pergolas to motorized louvered aluminum systems, Xavier Assembly installs structures that look architect-designed and last for decades. We review anchoring into concrete, pavers, decks and engineered footings for each project. Local requirements, installation availability and any specialist work are confirmed before scheduling.",
    heroImage:
      "https://static.prod-images.emergentagent.com/jobs/1271818a-d288-4bc7-b67d-404fdc5a13fe/images/a889022ea22b0a28830c0305ecf7f6a193a8a980b596ef94d6da1512c702c5af.png",
    benefits: [
      {
        title: "Modern Louvered Pergolas",
        desc: "Motorized aluminum pergolas with rain sensors, integrated LED, and rotating louvers — wired and finished correctly.",
      },
      {
        title: "Hardwood & Cedar Builds",
        desc: "Stained, sealed and torqued connections. We pre-drill, hide hardware, and protect end grain.",
      },
      {
        title: "Engineered Anchoring",
        desc: "Concrete footings, base plates and deck mounts are assessed for the product and site. Any engineering or local approvals needed are reviewed before work is agreed.",
      },
      {
        title: "Clean, Architectural Finish",
        desc: "We protect surfaces and leave the assembly work area tidy. Packaging, trash and pallet removal are included only when quoted and agreed.",
      },
    ],
    process: [
      "Site visit or photo-based consultation",
      "Fixed quote with anchoring method, materials, and delivery date",
      "Optional concrete pad / footing prep",
      "Pergola assembly: 1–2 days for standard 10×12 to 14×20",
      "Optional add-ons: LED lighting, curtains, ceiling fan support, electrical conduit",
    ],
    brands: ["StruXure", "Costco/Yardistry", "Sojag", "Paragon Outdoor", "Sunjoy", "Backyard Discovery"],
    faq: [
      {
        q: "How long does pergola installation take?",
        a: "Most freestanding 10×12 to 12×16 aluminum pergolas: one day. Motorized louvered models with electrical: 1.5 to 2 days. Large hardwood pergolas with footings: 2–3 days.",
      },
      {
        q: "Do you handle motorized louvered pergolas with electrical?",
        a: "Yes. We do the full mechanical install and rough-in. For final 110V connection in California we coordinate with a qualified electrician if your jurisdiction requires it.",
      },
      {
        q: "Can a pergola be attached to my house?",
        a: "Yes — we do attached (ledger-mounted) and freestanding installs. Attached pergolas require proper flashing and structural fastening; we have a standard detail we use across the Bay Area.",
      },
      {
        q: "Do you work in Reno's snow load zones?",
        a: "Yes. For Reno installations we recommend aluminum pergolas with a higher snow rating, or hardwood with reinforced beams. We'll spec the right product for your zip code.",
      },
    ],
    cta: "Get your free pergola quote",
  },

  "costco-gazebo-installer": {
    slug: "costco-gazebo-installer",
    canonical: "/costco-gazebo-installer",
    metaTitle:
      "Costco Gazebo Assembly Quote Requests Nationwide | Xavier Assembly",
    metaDescription:
      "Request a Costco gazebo assembly quote from anywhere in the U.S. Share your kit model, ZIP and site details; our team confirms local installation availability.",
    keywords:
      "costco gazebo installer, costco gazebo assembly, yardistry installer, yardistry assembly service, costco yardistry gazebo installer California, costco gazebo installation Bay Area",
    eyebrow: "Costco Gazebo Installer",
    h1: "Costco Gazebo Assembly Quote Requests Nationwide",
    intro:
      "Just bought a Yardistry, Sunjoy or Sojag gazebo from Costco? Share your model and site details for an assembly quote. Our crews know the exact assembly sequence, common missing-hardware fixes, and the finishing touches that turn a flat-pack kit into a structure that looks custom-built. Ask our team about customer references for projects in California and Reno.",
    heroImage:
      "https://static.prod-images.emergentagent.com/jobs/1271818a-d288-4bc7-b67d-404fdc5a13fe/images/0e18d599926d52d1c310172f23265e32cc0bb1a37c21f7d4ee36469143cdb97c.png",
    benefits: [
      {
        title: "Yardistry Experts",
        desc: "10×12, 12×14, 12×16, 14×16 — we know every Costco Yardistry SKU and have hardware on the truck for missing parts.",
      },
      {
        title: "We Pick Up From Costco",
        desc: "Don't have a truck? Add Costco pickup to your install — we collect, deliver, and assemble in one trip.",
      },
      {
        title: "Anchoring Included",
        desc: "Concrete, paver, deck or grass — anchoring hardware and labor included in your fixed quote.",
      },
      {
        title: "Sealed & Stained Options",
        desc: "Optional cedar staining, sealing and roof shingle install if your kit needs it.",
      },
    ],
    process: [
      "Tell us your Costco gazebo model (or send the box photo)",
      "Receive a written quote after project review",
      "We deliver (optional) or arrive at your site with hardware & tools",
      "Same-day assembly for 10×10 to 12×14; next-day completion for larger 14×16 with shingled roofs",
      "Final assembly-area cleanup; cardboard, packaging, trash and pallet removal only as quoted and agreed",
    ],
    brands: ["Yardistry", "Sunjoy", "Sojag", "Backyard Discovery", "Paragon Outdoor"],
    faq: [
      {
        q: "How much to install a Costco Yardistry gazebo?",
        a: "Most Costco Yardistry installations in California and Reno range from $950 to $2,200 depending on model size, foundation type, and whether shingles are included. Costco pickup is an optional add-on.",
      },
      {
        q: "Can you also pick up the gazebo from Costco for me?",
        a: "Yes — we offer optional Costco pickup as an add-on for Bay Area, Sacramento and Reno installs. You skip the rental truck and we deliver direct to your job site.",
      },
      {
        q: "What if my Costco kit has missing or damaged hardware?",
        a: "We carry common Yardistry hardware on the truck — bolts, brackets, connectors. If a major panel is damaged, we'll help you process the Costco return and reschedule at no extra labor charge.",
      },
      {
        q: "Do you install Costco Yardistry gazebos in Reno?",
        a: "Yes — Reno is one of our top markets for Costco gazebo installs. We make the drive regularly from California and bundle travel into a flat quote.",
      },
    ],
    cta: "Get your Costco gazebo install quote",
  },

  "yardistry-installer": {
    slug: "yardistry-installer",
    canonical: "/yardistry-installer",
    metaTitle:
      "Yardistry Installation Quote Requests Nationwide | Xavier Assembly",
    metaDescription:
      "Request a Yardistry gazebo or pergola assembly quote from anywhere in the U.S. Share your model and ZIP; our team confirms local installation availability.",
    keywords:
      "yardistry installer, yardistry assembly service California, yardistry gazebo installation, yardistry pavilion installer, yardistry pergola installer, yardistry installer Bay Area, yardistry installer Reno",
    eyebrow: "Yardistry Installer",
    h1: "Yardistry Installation Quote Requests Nationwide",
    intro:
      "Yardistry's premium cedar gazebos, pavilions and pergolas deserve more than a weekend warrior assembly. Xavier Assembly accepts Yardistry installation requests from homeowners in California and Reno. We pre-stain panels, hide hardware, and finish every joint to showroom standard.",
    heroImage:
      "https://static.prod-images.emergentagent.com/jobs/1271818a-d288-4bc7-b67d-404fdc5a13fe/images/6ae90a625581d82e34bdcd4f696e22ea4fe3ffc55c29abea2a2c3734569f9ceb.png",
    benefits: [
      {
        title: "Every Yardistry SKU",
        desc: "Meridian, Cambridge, Madison, Westport, Sutton, Riverside — we install the full Yardistry catalog plus their pavilions and pergolas.",
      },
      {
        title: "Cedar Finish Specialists",
        desc: "Pre-staining panels before assembly produces a flawless, even finish. We handle staining as an optional add-on.",
      },
      {
        title: "Roof, Shingle & Skylight",
        desc: "We install Yardistry's full roof systems including aluminum, asphalt shingles, and integrated skylight kits.",
      },
      {
        title: "Lighting & Electrical Prep",
        desc: "We pre-run conduit for ceiling fans, sconces or chandeliers during install — no retrofits later.",
      },
    ],
    process: [
      "Send us your Yardistry model & a few backyard photos",
      "Written quote after project review",
      "Optional pre-staining of cedar panels before assembly",
      "On-site assembly with the anchoring method agreed for your product and substrate",
      "Agreed roof and electrical-preparation work, and assembly-area cleanup; removal only as quoted and agreed",
    ],
    brands: ["Yardistry Meridian", "Yardistry Madison", "Yardistry Cambridge", "Yardistry Pavilion", "Yardistry Pergola"],
    faq: [
      {
        q: "How long does a Yardistry gazebo install take?",
        a: "Most 10×12 and 12×14 Yardistry gazebos are installed in one day. The 12×16 Meridian and larger pavilions with shingled roofs typically take 1.5 to 2 days.",
      },
      {
        q: "Can you stain my Yardistry before assembly?",
        a: "Yes — we strongly recommend pre-staining individual cedar panels before assembly for a flawless finish. We use Yardistry-recommended products and offer this as an add-on.",
      },
      {
        q: "Do you install Yardistry pavilions and large pergolas?",
        a: "Absolutely. Yardistry's Madison and Riverside pavilions are some of our favorite projects — we have crews specifically experienced in the larger SKUs.",
      },
      {
        q: "Do you install Yardistry products bought outside Costco?",
        a: "Yes — Yardistry direct, Sam's Club, Costco, Home Depot or Amazon. We install all kits regardless of retailer.",
      },
    ],
    cta: "Get your Yardistry install quote",
  },
};

export const CALL_PHONE = CALL_NOW;
